import * as THREE from 'three'

const _instance = new THREE.LoadingManager()
export default _instance